export default function cleanEmptyValues(object: any): any {
  return JSON.parse(
    JSON.stringify(object, (key, value) =>
      value === null || value === '' || (typeof value === 'string' && value.trim() === '') ? undefined : value
    )
  );
}
